export enum LocalStorageEnum {
    phone = 'phone',
    phoneSubmit = 'phone_submit',
    mail = 'mail',
    mailSubmit = 'mail_submit',
    expiresIn = 'expires_in',
    registerToken = 'register_token',
    smsTime = 'sms_time',
    codeTime = 'code_time',
    theme = 'theme',
    sawUpdate = 'saw_update',
    lang = 'lang',
    registered = 'registered',
    access_token = "access_token",
    refresh_token_time = "refresh_token_time",
    refresh_token = "refresh_token",
    captcha = "captcha",
    registerForm = "register_form",
    acceptLanguage = "accept_language",
    recoveryExpiresAt = "recovery_expires_at",
}
